import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px'
  }
});
